"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCashBalanceFormUploadUrl = exports.borrowerExpressPaths = exports.getN8nChatbotWebhookUrl = exports.getBorrowerExpressUrl = exports.getAdminExpressUrl = exports.getSlackConfigUrl = exports.getSlackInstallUrl = exports.getPlaidWebhookUrl = exports.getAdminReportUploadUrl = exports.getAdminReportTemplateUploadUrl = exports.getAuth0ClientId = exports.getAuth0ApiUrl = exports.getAuth0DomainUrl = exports.getAuth0CallbackUrl = exports.getAuth0Domain = exports.getAdminGraphqlapiUrl = exports.getApiUrl = exports.getGraphqlapiUrl = exports.getAdminGraphqlapiHostname = exports.getGraphqlapiHostname = exports.getCustomerDashboardUrl = exports.getAdminDashboardUrl = exports.getAdminDashboardHostname = exports.getApiGatewayHostname = exports.getAwsAccountId = void 0;
const _ = __importStar(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const error_1 = require("./error");
const utils = __importStar(require("./utils"));
/**
 * NOTE: Please use following standard naming convention based on rfc3986
 * https://datatracker.ietf.org/doc/html/rfc3986
 *
 * Given following url:
 * https://app.finleycms.com/path/to/api?query=something#panda
 * https://app.stage.finleycms.com/path/to/api
 *
 * protocol/scheme: https
 * subdomain: app(or app.stage)
 * SLD (second-level domain): finleycms
 * TLD (top-level domain): com
 * path: /path/to/api
 * query: query=something
 * fragment: panda
 * hostname/fqdn/authority: app.finleycms.com (combination of subdomain + SLD + TLD)
 * url: https://app.finleycms.com/path/to/api (combination of protocol, hostname, path)
 *
 * Finally, for internal const nameing:
 * prl - protocol-relative link (or protocol-relative URL) is a URL without specific scheme/protocol
 * ie) //app.finlycms.com/path/to/api
 */
const awsAccountIds = {
    development: '890870160103',
    stage: '890870160103',
    prod: '037351467533',
    'client-uat': '877680974148',
    client: '633570433267',
};
// TODO: app.finleycms.com are sprawling across our codebase also.  We need to consolidate this.
const apiGatewayHostnameForEnv = {
    test: 'localhost:9000', // TODO: consolidate me with `development`???
    development: 'localhost:9000',
    stage: 'api.stage.finleycms.com',
    prod: 'api.finleycms.com',
    'client-uat': 'api.client.uat.finleycms.com',
    client: 'api.client.finleycms.com',
};
const graphqlHostnameForEnv = {
    test: 'localhost:8000', // TODO: consolidate me with `development`???
    development: 'localhost:8000',
    stage: 'app.stage.finleycms.com',
    prod: 'app.finleycms.com',
    'client-uat': 'app.client.uat.finleycms.com',
    client: 'app.client.finleycms.com',
};
const graphqlAdminHostnameForEnv = {
    test: 'localhost:8001', // TODO: consolidate me with `development`???
    development: 'localhost:8001',
    stage: 'admin.stage.finleycms.com',
    prod: 'admin.finleycms.com',
    'client-uat': 'admin.client.uat.finleycms.com',
    client: 'admin.client.finleycms.com',
};
const customerDashboardHostname = {
    test: 'localhost:4000', // TODO: consolidate me with `development`???
    development: 'localhost:4000',
    stage: 'app.stage.finleycms.com',
    prod: 'app.finleycms.com',
    'client-uat': 'app.client.uat.finleycms.com',
    client: 'app.client.finleycms.com',
};
const adminDashboardHostname = {
    test: 'localhost:4001', // TODO: consolidate me with `development`???
    development: 'localhost:4001',
    stage: 'admin.stage.finleycms.com',
    prod: 'admin.finleycms.com',
    'client-uat': 'admin.client.uat.finleycms.com',
    client: 'admin.client.finleycms.com',
};
const auth0Domain = {
    test: 'dev-627joikrtvrw47zk.us.auth0.com',
    development: 'dev-627joikrtvrw47zk.us.auth0.com',
    stage: 'dev-627joikrtvrw47zk.us.auth0.com',
    prod: 'finleycms-prod-dashboard.us.auth0.com',
    'client-uat': 'finleycms-prod-dashboard.us.auth0.com',
    client: 'finleycms-prod-dashboard.us.auth0.com',
};
const auth0ClientId = {
    test: 'dNMUEyKnMMF853m5rYlIO3ZKI41jIEhw',
    development: 'dNMUEyKnMMF853m5rYlIO3ZKI41jIEhw',
    stage: 'dNMUEyKnMMF853m5rYlIO3ZKI41jIEhw',
    prod: 'D29x0lAlDRUI85Yf33lWrsPpUzLpyioj',
    'client-uat': '60mAkIWooxsQow3qnJlxnWCJ1L2JTZ6f',
    client: 'hCrEFwt5bf5QOvTQc8ZweBZphJHkJLW9',
};
/**
 * Prepend appropriate HTTP(s) protocol scheme for the environment
 */
const withHttpProtocol = (prl, env) => {
    const protocol = env === 'development' ? 'http' : 'https';
    return `${protocol}:${prl}`;
};
/**
 * get apigateway hostname
 */
const getApiGatewayHostnameByEnv = (env) => {
    const hostname = _.get(apiGatewayHostnameForEnv, env);
    (0, error_1.finleyAssert)(hostname, `apigateway hostname for [${env}] does not exist`);
    return hostname;
};
/**
 * getAdminDashboardHostname
 */
const getAdminDashboardHostnameByEnv = (env) => {
    const hostname = _.get(adminDashboardHostname, env);
    (0, error_1.finleyAssert)(hostname, `admin dashboard hostname for [${env}] does not exist`);
    return hostname;
};
/**
 * getCustomerDashboardHostname
 */
const getCustomerDashboardHostnameByEnv = (env) => {
    const hostname = _.get(customerDashboardHostname, env);
    (0, error_1.finleyAssert)(hostname, `customer dashboard hostname for [${env}] does not exist`);
    return hostname;
};
/**
 * Simple map look-up for now, since we don't have any clustering
 */
const getGraphqlapiHostnameByEnv = (env) => {
    const hostname = _.get(graphqlHostnameForEnv, env);
    (0, error_1.finleyAssert)(hostname, `graphqlapi hostname for [${env}] does not exist`);
    return hostname;
};
const getAdminGraphqlapiHostnameByEnv = (env) => {
    const hostname = _.get(graphqlAdminHostnameForEnv, env);
    (0, error_1.finleyAssert)(hostname, `graphqlapi hostname for [${env}] does not exist`);
    return hostname;
};
const getAuth0DomainByEnv = (env) => {
    const domain = _.get(auth0Domain, env);
    (0, error_1.finleyAssert)(domain, `auth0 domain for [${env}] does not exist`);
    return domain;
};
const getAuth0ClientIdByEnv = (env) => {
    const clientId = _.get(auth0ClientId, env);
    (0, error_1.finleyAssert)(clientId, `auth0 domain for [${env}] does not exist`);
    return clientId;
};
/**
 * Determines if the app should use relative URLs for API calls.
 * Returns true when running in a containerized environment (implementation-agent)
 * where nginx proxies /graphql to the backend.
 *
 * Detection: In vite dev mode, the dashboard runs on ports 4000/4001.
 * In containerized mode (impl-agent), it runs on ports 13000/13001/80/443/444.
 * If we're not on the vite dev ports, use relative URLs.
 */
const shouldUseRelativeUrls = () => {
    if (typeof window === 'undefined')
        return false;
    const { port } = window.location;
    const viteDevPorts = ['4000', '4001'];
    return !viteDevPorts.includes(port);
};
// ========== Public methods ==========
/**
 * gets aws account id
 */
const getAwsAccountId = () => {
    const env = utils.EnvUtils.getEnv();
    return awsAccountIds[env];
};
exports.getAwsAccountId = getAwsAccountId;
const getApiGatewayHostname = () => {
    const env = utils.EnvUtils.getEnv();
    return getApiGatewayHostnameByEnv(env);
};
exports.getApiGatewayHostname = getApiGatewayHostname;
const getAdminDashboardHostname = () => {
    const env = utils.EnvUtils.getEnv();
    return getAdminDashboardHostnameByEnv(env);
};
exports.getAdminDashboardHostname = getAdminDashboardHostname;
const getAdminDashboardUrl = () => {
    const env = utils.EnvUtils.getEnv();
    const prl = `//${getAdminDashboardHostnameByEnv(env)}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminDashboardUrl = getAdminDashboardUrl;
const getCustomerDashboardUrl = () => {
    const env = utils.EnvUtils.getEnv();
    const prl = `//${getCustomerDashboardHostnameByEnv(env)}`;
    return withHttpProtocol(prl, env);
};
exports.getCustomerDashboardUrl = getCustomerDashboardUrl;
const getGraphqlapiHostname = () => {
    const env = utils.EnvUtils.getEnv();
    return getGraphqlapiHostnameByEnv(env);
};
exports.getGraphqlapiHostname = getGraphqlapiHostname;
const getAdminGraphqlapiHostname = () => {
    const env = utils.EnvUtils.getEnv();
    return getAdminGraphqlapiHostnameByEnv(env);
};
exports.getAdminGraphqlapiHostname = getAdminGraphqlapiHostname;
const getGraphqlapiUrl = () => {
    const env = utils.EnvUtils.getEnv();
    if (env === 'development' && shouldUseRelativeUrls()) {
        return '/graphql';
    }
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/graphql`;
    return withHttpProtocol(prl, env);
};
exports.getGraphqlapiUrl = getGraphqlapiUrl;
const getApiUrl = () => {
    const env = utils.EnvUtils.getEnv();
    if (env === 'development' && shouldUseRelativeUrls()) {
        return '';
    }
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}`;
    return withHttpProtocol(prl, env);
};
exports.getApiUrl = getApiUrl;
const getAdminGraphqlapiUrl = () => {
    const env = utils.EnvUtils.getEnv();
    if (env === 'development' && shouldUseRelativeUrls()) {
        return '/graphql';
    }
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/graphql`;
    return withHttpProtocol(prl, env);
};
exports.getAdminGraphqlapiUrl = getAdminGraphqlapiUrl;
const getAuth0Domain = () => {
    const env = utils.EnvUtils.getEnv();
    return getAuth0DomainByEnv(env);
};
exports.getAuth0Domain = getAuth0Domain;
const getAuth0CallbackUrl = () => {
    const env = utils.EnvUtils.getEnv();
    const hostname = (0, exports.getGraphqlapiHostname)();
    const prl = `//${hostname}/auth0`;
    return withHttpProtocol(prl, env);
};
exports.getAuth0CallbackUrl = getAuth0CallbackUrl;
const getAuth0DomainUrl = () => {
    const hostname = (0, exports.getAuth0Domain)();
    // always https
    return `https://${hostname}`;
};
exports.getAuth0DomainUrl = getAuth0DomainUrl;
const getAuth0ApiUrl = () => {
    const env = utils.EnvUtils.getEnv();
    const hostname = getAuth0DomainByEnv(env);
    return `https://${hostname}/api/v2`;
};
exports.getAuth0ApiUrl = getAuth0ApiUrl;
const getAuth0ClientId = () => {
    const env = utils.EnvUtils.getEnv();
    return getAuth0ClientIdByEnv(env);
};
exports.getAuth0ClientId = getAuth0ClientId;
// generates static admin api route base url to upload report-templates
const getAdminReportTemplateUploadUrl = (reportType) => {
    const env = utils.EnvUtils.getEnv();
    const endpoint = _.includes(_.values(finley_types_1.Report.DocxReportTemplateType), reportType)
        ? 'docx'
        : _.kebabCase(reportType);
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/report-templates/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminReportTemplateUploadUrl = getAdminReportTemplateUploadUrl;
const getAdminReportUploadUrl = () => {
    const env = utils.EnvUtils.getEnv();
    const endpoint = 'reports';
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminReportUploadUrl = getAdminReportUploadUrl;
const getPlaidWebhookUrl = () => {
    const env = utils.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/plaid/services/webhook`;
    return withHttpProtocol(prl, env);
};
exports.getPlaidWebhookUrl = getPlaidWebhookUrl;
const getSlackInstallUrl = () => {
    // Use stage env hostname for development env
    const env = utils.EnvUtils.isDevelopment()
        ? 'stage'
        : utils.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/slack/install`;
    return withHttpProtocol(prl, env);
};
exports.getSlackInstallUrl = getSlackInstallUrl;
const getSlackConfigUrl = () => {
    // Use stage env hostname for development env
    const env = utils.EnvUtils.isDevelopment()
        ? 'stage'
        : utils.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}`;
    return withHttpProtocol(prl, env);
};
exports.getSlackConfigUrl = getSlackConfigUrl;
const getAdminExpressUrl = (endpoint) => {
    const env = utils.EnvUtils.getEnv();
    const hostname = getAdminGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getAdminExpressUrl = getAdminExpressUrl;
const getBorrowerExpressUrl = (endpoint) => {
    const env = utils.EnvUtils.getEnv();
    const hostname = getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getBorrowerExpressUrl = getBorrowerExpressUrl;
const getN8nChatbotWebhookUrl = () => {
    const env = utils.EnvUtils.getEnv();
    const webhookId = 'f2de1616-7643-4b77-bbdd-05cefd524d74';
    switch (env) {
        case 'development':
            // Local development: use local n8n
            return `http://localhost:5678/webhook-test/${webhookId}`;
        case 'stage':
            return `https://n8n.stage.finleycms.com/webhook-test/${webhookId}`;
        case 'prod':
            return `https://n8n.finleycms.com/webhook/${webhookId}`;
        // Disabled envs
        case 'client-uat':
        case 'client':
            throw new Error(`N8N chatbot webhook is disabled for environment: ${env}`);
        default:
            // Switch pattern since we want to be exhaustive for unknown envs
            return (0, error_1.finleyAssertUnreachable)(env, `Unhandled env in getN8nChatbotWebhookUrl: ${env}`);
    }
};
exports.getN8nChatbotWebhookUrl = getN8nChatbotWebhookUrl;
var borrowerExpressPaths;
(function (borrowerExpressPaths) {
    borrowerExpressPaths["cashBalanceFormUpload"] = "manual-datatape-upload/cash-balance-form";
    borrowerExpressPaths["dataTapeUploadCapitalProvider"] = "manual-datatape-upload/data-tape-capital-provider";
    borrowerExpressPaths["assignByCSVPreviewGenAndCSVUpload"] = "assignment/assign-by-csv/preview-gen-file-upload";
    borrowerExpressPaths["assignmentCSVValidation"] = "assignment/file-structure-validation";
    borrowerExpressPaths["reassignByCSV"] = "assignment/reassign-by-csv";
})(borrowerExpressPaths || (exports.borrowerExpressPaths = borrowerExpressPaths = {}));
const getCashBalanceFormUploadUrl = ({ admin, }) => {
    const endpoint = borrowerExpressPaths.cashBalanceFormUpload;
    const env = utils.EnvUtils.getEnv();
    const hostname = admin
        ? getAdminGraphqlapiHostnameByEnv(env)
        : getGraphqlapiHostnameByEnv(env);
    const prl = `//${hostname}/${endpoint}`;
    return withHttpProtocol(prl, env);
};
exports.getCashBalanceFormUploadUrl = getCashBalanceFormUploadUrl;
//# sourceMappingURL=url.js.map